import { render, staticRenderFns } from "./MainInfoVideo.vue?vue&type=template&id=1e327890&"
import script from "./MainInfoVideo.vue?vue&type=script&lang=js&"
export * from "./MainInfoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports